import { text } from "stream/consumers";
import styled from "styled-components";
import { TextContainer } from "./containers";

const IconContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  img {
    width: 25px;
    height: 25px;
    object-fit: contain;
  }
  height: 25px;
`;

export function IconText(props: { text: string; icon?: string }) {
  return (
    <IconContainer>
      <img src={`/event/icons/${props.icon}.webp`} />
      {props.text}
    </IconContainer>
  );
}
export const IconCt = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
`;
export const IconRows = styled(TextContainer)`
  display: flex;
  flex-direction: row;
  gap: 40px;
`;
